/**
 * @generated SignedSource<<d71479672c8fb68a82a7fdae1e7f60be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type thisWeekInAsiaDiscoveryWidgetQuery$data = {
  readonly twiaQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"sectionTwiaContentItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly twiaSection: {
    readonly urlAlias: string;
  };
  readonly " $fragmentType": "thisWeekInAsiaDiscoveryWidgetQuery";
};
export type thisWeekInAsiaDiscoveryWidgetQuery$key = {
  readonly " $data"?: thisWeekInAsiaDiscoveryWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"thisWeekInAsiaDiscoveryWidgetQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "thisWeekInAsiaDiscoveryWidgetQuery",
  "selections": [
    {
      "alias": "twiaSection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "323045"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"323045\"})"
    },
    {
      "alias": "twiaQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "section_top_323045"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sectionTwiaContentItemContent"
                        }
                      ],
                      "type": "Article",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:5)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "0720d02b82cf8f004a17d660a86e69c6";

export default node;
